// extracted by mini-css-extract-plugin
module.exports = {"singleProjectTechContainer":"styles_singleProjectTechContainer__3s1_b","otherExperienceSection":"styles_otherExperienceSection__3sRqV"};